import { Seo, localBusinessLD } from "../lib/seo";
import QuoteForm from "../components/QuoteForm";
import { Reveal } from "../components/Reveal";
import { SITE } from "../data/site";

export default function DevisPage() {
    return (
        <>
            <Seo
                title="Devis gratuit sous 48 h — Peinture, parquet & carrelage | Solino Pro"
                description="Demandez votre devis gratuit en 2 minutes : décrivez votre projet, joignez des photos, recevez un chiffrage détaillé sous 48 h ouvrées. Artisan à Chaumont-en-Vexin."
                path="/devis"
                jsonld={localBusinessLD()}
            />

            <section className="relative pt-36 pb-20 lg:py-28 overflow-hidden" data-testid="devis-page">
                <div className="absolute inset-0 opacity-[0.06] pointer-events-none" aria-hidden="true">
                    <img src="https://images.unsplash.com/photo-1717281234297-3def5ae3eee1?q=80&w=1800&auto=format&fit=crop" alt="" className="w-full h-full object-cover" />
                </div>
                <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
                    <div className="max-w-3xl mx-auto text-center mb-14">
                        <Reveal>
                            <p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold mb-5">
                                Devis gratuit — réponse sous 48 h ouvrées
                            </p>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <h1 className="text-4xl sm:text-6xl font-light tracking-tighter leading-[1.02] text-ivory">
                                Parlez-nous de votre projet,{" "}
                                <span className="font-display italic text-gold">on s'occupe du reste.</span>
                            </h1>
                        </Reveal>
                        <Reveal delay={0.16}>
                            <p className="mt-6 text-smoke leading-relaxed max-w-2xl mx-auto">
                                Quatre étapes, deux minutes. Les photos de votre chantier nous font
                                gagner du temps — et vous font gagner sur le chiffrage.
                            </p>
                        </Reveal>
                    </div>

                    <QuoteForm />

                    <Reveal delay={0.1}>
                        <div className="max-w-3xl mx-auto mt-14 border border-linew bg-coal/70 p-7 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5" data-testid="devis-call-alternative">
                            <div>
                                <p className="text-ivory font-medium">Plus simple par téléphone ?</p>
                                <p className="mt-1 text-sm text-smoke">
                                    Appelez-nous, {SITE.hours}. Réponse directe de l'artisan, pas d'standard.
                                </p>
                            </div>
                            <a
                                href={SITE.phoneHref}
                                className="shrink-0 rounded-full bg-gold text-ink font-bold px-8 py-4 hover:scale-[1.04] transition-transform"
                                data-testid="devis-page-call"
                            >
                                {SITE.phoneDisplay}
                            </a>
                        </div>
                    </Reveal>
                </div>
            </section>
        </>
    );
}
